import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import Lenis from "lenis";
import { Toaster } from "@/components/ui/sonner";
import { trackPage } from "@/lib/tracker";
import Home from "@/pages/Home";
import Company from "@/pages/Company";
import Supply from "@/pages/Supply";
import RequestPage from "@/pages/Request";
import Contact from "@/pages/Contact";
import Register from "@/pages/Register";
import Unsubscribe from "@/pages/Unsubscribe";
import Products from "@/pages/Products";
import ProductPage from "@/pages/ProductPage";
import NotFound from "@/pages/NotFound";
import { PrivacyPage, TermsPage } from "@/pages/Legal";
import Admin from "@/pages/Admin";

const ScrollManager = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    if (window.__lenis) window.__lenis.scrollTo(0, { immediate: true });
    else window.scrollTo(0, 0);
    trackPage();
  }, [pathname]);
  return null;
};

function App() {
  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.09, smoothWheel: true });
    window.__lenis = lenis;
    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
      window.__lenis = null;
    };
  }, []);

  return (
    <HelmetProvider>
      <BrowserRouter>
        <ScrollManager />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/company" element={<Company />} />
          <Route path="/supply" element={<Supply />} />
          <Route path="/request" element={<RequestPage />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/register" element={<Register />} />
          <Route path="/products" element={<Products />} />
          <Route path="/products/:slug" element={<ProductPage />} />
          <Route path="/unsubscribe" element={<Unsubscribe />} />
          <Route path="/preferences" element={<Unsubscribe />} />
          <Route path="/privacy" element={<PrivacyPage />} />
          <Route path="/terms" element={<TermsPage />} />
          <Route path="/admin" element={<Admin />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
        <Toaster theme="light" position="bottom-right" />
      </BrowserRouter>
    </HelmetProvider>
  );
}

export default App;
